import "@/TRC/pages/Access/components/trcHeading/trcTitle.css"

const TRCFormTitle = ({ children, tagline }) => {
	return (
		<div className="trc-form-title-container text-center text-white">
			<div className="trc-form-title text-uppercase fw-bold">{children}</div>
			{tagline && <div className="trc-form-tagline mt-1">{tagline}</div>}
			<p className='trc-form-subtitle mt-1'>The Teacher Resource Center is exclusively for dance educators.</p>
		</div>
	);
};

export default TRCFormTitle;
